/**
 * Muscle constants - browser-safe, zero imports.
 * This is the foundation file that other muscle files build upon.
 */
// We will have labels for the anatomy in i18n section of the user interface
const muscleAnatomyTypes = {
    REGION: 'region',
    GROUP: 'group',
    MUSCLE: 'muscle',
};
export { muscleAnatomyTypes };
//# sourceMappingURL=muscle.constants.js.map